module.exports = __webpack_public_path__ + "static/media/features8.6a12f692.jpg";